import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21.7 1.4C19.1-.8 15.3-.4 13 2l-1 1-.9-1C8.7-.4 4.9-.8 2.3 1.4c-2.9 2.5-3.1 7-.5 9.7l9.1 9.4c.6.6 1.5.6 2.1 0l9.1-9.4c2.7-2.6 2.5-7.2-.4-9.7z" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "heart-filled"}) } }